module.exports = __webpack_public_path__ + "img/no_frame.821e0997.svg";